<template>
  <v-app :key="$route.fullPath" class="blue-grey lighten-5">
    <router-view></router-view>
  </v-app>
</template>

<script>
export default {
  name: "app"
};
</script>

<style lang="stylus">
  @import url('https://fonts.googleapis.com/icon?family=Material+Icons')
  @import './stylus/main'

</style>



// WEBPACK FOOTER //
// src/App.vue